export default defineComponent({
  name: 'CardPlaceholder'
});